/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateTeacherResponse } from './CreateTeacherResponse';
import {
    CreateTeacherResponseFromJSON,
    CreateTeacherResponseFromJSONTyped,
    CreateTeacherResponseToJSON,
    CreateTeacherResponseToJSONTyped,
} from './CreateTeacherResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateTeacherResponse
 */
export interface ResultOfCreateTeacherResponse {
    /**
     * 
     * @type {CreateTeacherResponse}
     * @memberof ResultOfCreateTeacherResponse
     */
    data: CreateTeacherResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateTeacherResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateTeacherResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateTeacherResponse interface.
 */
export function instanceOfResultOfCreateTeacherResponse(value: object): value is ResultOfCreateTeacherResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateTeacherResponseFromJSON(json: any): ResultOfCreateTeacherResponse {
    return ResultOfCreateTeacherResponseFromJSONTyped(json, false);
}

export function ResultOfCreateTeacherResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateTeacherResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateTeacherResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateTeacherResponseToJSON(json: any): ResultOfCreateTeacherResponse {
    return ResultOfCreateTeacherResponseToJSONTyped(json, false);
}

export function ResultOfCreateTeacherResponseToJSONTyped(value?: ResultOfCreateTeacherResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateTeacherResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

